import { render, staticRenderFns } from "./wf.vue?vue&type=template&id=9fbd6e14&scoped=true&"
import script from "./wf.vue?vue&type=script&lang=ts&"
export * from "./wf.vue?vue&type=script&lang=ts&"
import style0 from "./wf.vue?vue&type=style&index=0&id=9fbd6e14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbd6e14",
  null
  
)

export default component.exports